import { Record } from 'immutable'
import { Area, IArea } from './Area'
import { IAssociatedProperty } from './AssociatedProperty'
import { IAttachment } from './Attachment'

export interface ISuccessStory {
  readonly id: string
  readonly action: string
  readonly challenge: string
  readonly dateCreated: number
  readonly description: string
  readonly outline: string
  readonly property: IAssociatedProperty
  readonly propertyPhoto: IAttachment
  readonly results: string
  readonly title: string
}

const SuccessStoryRecord = Record({
  id: '',
  action: '',
  challenge: '',
  dateCreated: 0,
  description: '',
  outline: '',
  results: '',
  property: undefined,
  propertyPhoto: undefined,
  title: '',
})

export class SuccessStory extends SuccessStoryRecord implements ISuccessStory {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new SuccessStory()
    }

    return new SuccessStory({
      ...initialState,
    })
  }

  readonly id: string
  readonly action: string
  readonly challenge: string
  readonly dateCreated: number
  readonly description: string
  readonly outline: string
  readonly results: string
  readonly property: IAssociatedProperty
  readonly propertyPhoto: IAttachment
  readonly title: string

  constructor(props?: Partial<SuccessStory>) {
    props ? super(props) : super()
  }
}
